import { Box, Stack } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import React, { useState } from 'react';
import { Link, navigate } from 'gatsby';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';
import { useMediaQuery } from '@chakra-ui/react';
import { useABTesting } from '../../../hooks';
import { ctaABTesting } from '../../../utils/ctaABTesting';

const ButtonsGroup: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isDesktop] = useMediaQuery('(min-width: 1280px)');
  const abTestValue = useABTesting({
    testName: 'insurance-resolution-cta-pressed',
  });

  if (!abTestValue) return <>Loading...</>;

  const toggleModal = () => {
    if (!isDesktop) setIsOpen(!isOpen);
    else if (abTestValue === 'A') {
      ctaABTesting('A');
      setIsOpen(!isOpen);
    } else {
      ctaABTesting('B');
      void navigate('/signup');
    }
  };

  return (
    <Stack
      spacing={500}
      my={700}
      direction={{ base: 'column', desktop: 'row' }}
      alignItems="center"
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Box
        flexDir={{ base: 'column', tablet: 'row' }}
        alignItems={{ base: 'center', tablet: 'flex-start' }}
        mt={800}
        w={{ base: '100%', tablet: 'auto' }}
      >
        <Button
          onClick={toggleModal}
          colorScheme="primary"
          variant="solid"
          whiteSpace="nowrap"
          mb={{ base: 500, desktop: 0 }}
          w={{ base: '323px', tablet: 'auto' }}
        >
          Start measuring in minutes
        </Button>
        <ArrowButton
          flex={0}
          variant="minimal"
          whiteSpace="nowrap"
          ml={500}
          as={Link}
          to="/pricing/"
        >
          Go to pricing
        </ArrowButton>
      </Box>
    </Stack>
  );
};

export default ButtonsGroup;
